import { RouterState } from 'redux-first-history';

const nullRouterState = {
  location: null,
  action: null,
  previousLocations: [],
};

export const nullRouterReducer = (): RouterState => nullRouterState;
